import React, { useState } from "react";
import "./styles.scss";

const InputBox = ({
  label,
  type = "text",
  placeholder = "Enter here",
  value,
  onChange,
  name,
  required = false,
  maxLength,
  inputStyle = {},
  icon = null,
  checked,
  labelStyle,
  disabled,
  defaultValue,
  isPassword = false, // Add a prop to determine if the field is a password field
}) => {
  const [passwordVisible, setPasswordVisible] = useState(false); // State to toggle password visibility

  const togglePasswordVisibility = () => {
    setPasswordVisible((prevState) => !prevState);
  };

  return (
    <div className="input-container">
      {label && (
        <label style={labelStyle} htmlFor={name}>
          {label}
        </label>
      )}
      <div className="input-wrapper">
        {icon && <img src={icon} alt="icon" className="input-icon" />}
        <input
          type={isPassword && passwordVisible ? "text" : type}
          id={name}
          name={name}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          required={required}
          maxLength={maxLength}
          style={inputStyle}
          checked={checked}
          disabled={disabled}
          className={icon ? "input-with-icon" : isPassword ? "input-with-password" : ''}
          defaultValue={defaultValue}
        />
        {/* Eye icon for password toggle */}
        {isPassword && (
          <span
            className="passwordIcon"
            onClick={togglePasswordVisibility}
          >
            {passwordVisible ? "👁️" : "👁️‍🗨️"}
          </span>
        )}
      </div>
    </div>
  );
};

export default InputBox;
